import { useState } from "react";
import type { DateRange } from "react-day-picker";
import DateRangePicker from "@/components/ui/date-range-picker";
import AlertsPanel from "./alerts-panel";
import ScorecardRow from "./scorecard-row";
import OperatorTable from "./operator-table";
import CustomerHealthPanel from "./customer-health-panel";
import CumulativeOrdersChart from "./cumulative-orders-chart";
import { useCarrierScope } from "@/contexts/carrier-scope-context";

export default function AnalyticsDashboard() {
  // TODO(carrier-scope): the analytics panels (alerts, scorecards, operator
  // table, customer health, cumulative orders chart) are all cross-carrier
  // today. Per-carrier and per-dispatch-center views need server-side
  // aggregations to be scoped first; wire both pickers when those land.
  const { carrierIds, dispatchCenterIds } = useCarrierScope();
  void carrierIds;
  void dispatchCenterIds;
  const [dateRange, setDateRange] = useState<DateRange>({
    from: new Date(new Date().setDate(new Date().getDate() - 30)),
    to: new Date(),
  });

  return (
    <div className="container mx-auto py-8 px-4 space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <h1 className="text-3xl font-bold">Analytics Dashboard</h1>
        <DateRangePicker date={dateRange} onDateChange={setDateRange} />
      </div>

      {/* Section 1: Alerts - Problems needing attention */}
      <AlertsPanel />

      {/* Section 2: Scorecard - Today's metrics with comparisons */}
      <section>
        <h2 className="text-xl font-semibold mb-4">Today at a Glance</h2>
        <ScorecardRow />
      </section>

      {/* Section 3: Operator Performance Table */}
      <section>
        <OperatorTable dateRange={dateRange} />
      </section>

      {/* Section 4: Customer Health */}
      <section>
        <CustomerHealthPanel dateRange={dateRange} />
      </section>

      <section>
        <CumulativeOrdersChart />
      </section>
    </div>
  );
}
